import { css, FASTElement, html } from "@microsoft/fast-element";
import { NatGenDesignSystem } from "../../natgen-design-system";

/**
 * @element natgen-portal-outlet
 * TODO:
 *  - Override step slotted content from parent using projection?
 *  - Animate active icon moving across states?
 */
export class NatGenWizardStepper extends FASTElement {

}

export const natGenWizardStepperDefinition = NatGenWizardStepper.compose({
    name: `${NatGenDesignSystem.prefix}-wizard-stepper`,
    styles: css`
        :host {
            display: flex;
        }
    `,
    template: html<NatGenWizardStepper>`
        <slot></slot>
    `
});
